import { safeUserLabel } from "../../../utils/adminLevelUtils";
import { Users, CheckCircle } from "lucide-react";

const UsersSection = ({ t, styles, selectedCompanies, usersByCompany, selectedUsers, search, onToggleUser, onToggleAllCompanyUsers, onToggleAllGlobal, theme }) => (
  <div style={{
    borderRadius: "12px",
    border: `2px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
    padding: "20px",
    backgroundColor: theme === "dark" ? "rgba(30,41,59,0.5)" : "rgba(248,250,252,0.8)",
    background: theme === "dark"
      ? "linear-gradient(135deg, rgba(30,41,59,0.5) 0%, rgba(15,23,42,0.3) 100%)"
      : "linear-gradient(135deg, rgba(248,250,252,0.8) 0%, rgba(240,249,255,0.6) 100%)",
    transition: "all 0.3s ease"
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Users size={20} style={{ color: "#10B981" }} />
        <div style={{
          fontSize: "15px",
          fontWeight: "700",
          color: theme === "dark" ? "#f1f5f9" : "#0f172a"
        }}>
          {t.users}
        </div>
      </div>
      {selectedCompanies.length > 0 && (
        <label style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          padding: "6px 12px",
          borderRadius: "6px",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
          <input
            type="checkbox"
            checked={selectedCompanies.every((co) => {
              const allUsers = usersByCompany[co] || [];
              const selectedUsrs = selectedUsers[co] || [];
              return allUsers.length > 0 && allUsers.every((u) => selectedUsrs.includes(u.id));
            })}
            onChange={onToggleAllGlobal}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#10B981"
            }}
          />
          <span style={{ fontSize: "13px", fontWeight: "500", color: theme === "dark" ? "#cbd5e1" : "#475569" }}>{t.selectAll}</span>
        </label>
      )}
    </div>

    {selectedCompanies.length === 0 ? (
      <div style={{
        padding: "20px 16px",
        borderRadius: "8px",
        backgroundColor: theme === "dark" ? "rgba(226,232,240,0.05)" : "rgba(16, 185, 129, 0.05)",
        border: `1px dashed ${theme === "dark" ? "rgba(226,232,240,0.2)" : "rgba(16, 185, 129, 0.2)"}`,
        textAlign: "center",
        color: theme === "dark" ? "rgba(226,232,240,0.6)" : "rgba(15,23,42,0.6)",
        fontSize: "13px"
      }}>
        {t.selectAtLeastOne}
      </div>
    ) : (
      <div style={{ display: "grid", gap: "20px" }}>
        {selectedCompanies.map((co) => {
          const allUsers = usersByCompany[co] || [];
          const filteredUsers = allUsers.filter((u) => !search || safeUserLabel(u).toLowerCase().includes(search.toLowerCase()));

          return (
            <div key={co} style={{
              borderRadius: "10px",
              padding: "16px",
              backgroundColor: theme === "dark" ? "rgba(15,23,42,0.6)" : "rgba(255,255,255,0.5)",
              border: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                <div style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: theme === "dark" ? "#cbd5e1" : "#334155"
                }}>
                  {co} ({filteredUsers.length})
                </div>
                {filteredUsers.length > 0 && (
                  <label style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    fontSize: "12px"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
                    <input
                      type="checkbox"
                      checked={filteredUsers.length > 0 && filteredUsers.every((u) => (selectedUsers[co] || []).includes(u.id))}
                      onChange={() => onToggleAllCompanyUsers(co)}
                      style={{
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                        accentColor: "#10B981"
                      }}
                    />
                    <span style={{ fontWeight: "500", color: theme === "dark" ? "#cbd5e1" : "#475569" }}>{t.selectAll}</span>
                  </label>
                )}
              </div>

              <div style={{ display: "grid", gap: "8px" }}>
                {filteredUsers.length === 0 ? (
                  <p style={{ margin: 0, fontSize: "12px", color: theme === "dark" ? "rgba(226,232,240,0.4)" : "rgba(15,23,42,0.4)" }}>
                    {search ? t.noUsers : t.noUsers}
                  </p>
                ) : (
                  filteredUsers.slice(0, 200).map((user) => {
                    const isSelected = (selectedUsers[co] || []).includes(user.id);
                    const userLabel = safeUserLabel(user);
                    const userEmail = user?.employee?.email || user?.email || "";
                    const initials = user?.name?.charAt(0)?.toUpperCase() || "U";

                    return (
                      <button
                        key={`${co}__u__${user.id}`}
                        onClick={() => onToggleUser(co, user.id)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                          padding: "12px 14px",
                          borderRadius: "8px",
                          border: `1px solid ${isSelected ? "rgba(16, 185, 129, 0.3)" : theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`,
                          backgroundColor: isSelected ? "rgba(16, 185, 129, 0.12)" : "transparent",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          background: "none",
                          fontFamily: "inherit",
                          textAlign: "left"
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.05)" : "rgba(15,23,42,0.03)";
                            e.currentTarget.style.transform = "translateX(4px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.backgroundColor = "transparent";
                            e.currentTarget.style.transform = "translateX(0)";
                          }
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "14px", flex: 1 }}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => onToggleUser(co, user.id)}
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              accentColor: "#10B981",
                              flexShrink: 0
                            }}
                          />
                          <div style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "8px",
                            backgroundColor: "rgba(16, 185, 129, 0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#10B981",
                            fontWeight: "700",
                            fontSize: "14px",
                            flexShrink: 0
                          }}>
                            {initials}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              fontWeight: isSelected ? "600" : "500",
                              fontSize: "13px",
                              color: isSelected ? "#10B981" : (theme === "dark" ? "#cbd5e1" : "#334155"),
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}>
                              {userLabel}
                            </div>
                            {userEmail && (
                              <div style={{
                                fontSize: "11px",
                                color: theme === "dark" ? "rgba(226,232,240,0.5)" : "rgba(15,23,42,0.5)",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}>
                                {userEmail}
                              </div>
                            )}
                          </div>
                        </div>
                        {isSelected && <CheckCircle size={20} style={{ color: "#10B981", flexShrink: 0 }} />}
                      </button>
                    );
                  })
                )}
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default UsersSection;

